<template>
    <div class="dash-cell" :class="{'cell-values-zero': areAllValuesZero}">
        <div v-for="item in getItems" :key="item.item.id" class="dash-row">
            <div class="dash-field dash-name">
                <span :title="`#${item.quote.id} - #${item.item.id}`">
                    <strong>{{ item.quote.name | maxchars(30) }}</strong> <span class="dash-separator">-</span> {{ item.item.name | maxchars(40) }}
                </span>
                <dash-badge v-if="toDo" :seconds="item.seconds_todo" title="Time Required"></dash-badge>
                <dash-badge v-if="inProgress" :seconds="item.seconds_todo" title="Time Required"></dash-badge>
                <dash-badge v-if="inProgress" :percent="item.percent_done" title="Percent Done"></dash-badge>
                <dash-badge v-if="done" :seconds="item.seconds_done" title="Time Spent"></dash-badge>
                <dash-badge v-if="done" :percent="item.percent_change" percent_type="reverse" title="Percent Difference From Estimation"></dash-badge>
            </div>
        </div>
        <div class="dash-row dash-totals">
            <div class="dash-totals-section">
                <dash-badge :quantity="totalItemCount" title="# Items"></dash-badge>
            </div>
            <div v-if="toDo" class="dash-totals-section">
                <dash-badge :seconds="totalSecondsTodo" title="Time Required"></dash-badge>
            </div>
            <div v-if="inProgress" class="dash-totals-section">
                <dash-badge :seconds="totalSecondsTodo" title="Time Required"></dash-badge>
            </div>
            <div v-if="inProgress" class="dash-totals-section">
                <dash-badge :percent="totalPercentDone" title="Percent Done"></dash-badge>
            </div>
            <div v-if="done" class="dash-totals-section">
                <dash-badge :seconds="totalSecondsDone" title="Time Spent"></dash-badge>
            </div>
            <div v-if="done" class="dash-totals-section">
                <dash-badge :percent="totalPercentChange" percent_type="reverse" title="Percent Difference From Estimation"></dash-badge>
            </div>
        </div>
    </div>
</template>

<script>
    import Timer from './Timer.vue';
    import DashProgressBar from './DashProgressBar';
    import DashBadge from './DashBadge';

    export default {
        props: {
            data: {},
            now: {
                type: Number,
                required: true,
            },
            // to_do, in_progress, done
            type: {
                type: String,
                required: true,
            }
        },
        components: {
            Timer,
            DashProgressBar,
            DashBadge
        },
        methods: {
            isObject(obj) {
                return obj != null && obj.constructor.name === "Object"
            }
        },
        computed: {
            areAllValuesZero() {
                return this.totalItemCount === 0
                    && this.totalSecondsTodo === 0
                    && this.totalPercentDone === 0
                    && this.totalSecondsDone === 0
                    && this.totalPercentChange === 0;
            },
            toDo() {
                return this.type === 'to_do';
            },
            inProgress() {
                return this.type === 'in_progress';
            },
            done() {
                return this.type === 'done';
            },
            totalPercentDone() {
                return this.haveTotals ? this.data.totals.percent_done : 0;
            },
            totalPercentChange() {
                return this.haveTotals ? this.data.totals.percent_change : 0;
            },
            totalSecondsDone() {
                return this.haveTotals ? this.data.totals.seconds_done : 0;
            },
            totalSecondsTotal() {
                return this.haveTotals ? this.data.totals.seconds_total : 0;
            },
            totalSecondsTodo() {
                return this.haveTotals ? this.data.totals.seconds_todo : 0;
            },
            totalItemCount() {
                return this.haveTotals ? this.data.totals.items_count : 0;
            },
            haveItems() {
                return Array.isArray(this.data.items) && this.data.items.length > 0;
            },
            haveTotals() {
                return this.isObject(this.data.totals) && Object.keys(this.data.totals).length;
            },
            getItems() {
                return this.haveItems ? this.data.items : [];
            },
        },
    }
</script>

<style>
    .dash-cell {
        width: 100%;
        height: 100%;
        position: relative;
        padding-bottom: 58px;
        background-color: #2A2A2A;
    }
    .dash-row {
        width: 100%;
        border-bottom: 2px solid #111214;
        padding: calc(5px + 0.1vw) calc(10px + 0.1vw);
        display: inline-block;
        color: #cbcbcb;
    }
    .dash-totals {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 60px;
        text-align: center;
        background-color: #3e3e3e;
        display: flex;
        padding: 0;
    }
    .dash-totals-section {
        flex: auto;
        padding: 0;
        margin: 0;
        height: 100%;
        border: 1px solid #101113;
        border-top-width: 2px;
    }
    .dash-totals-section:first-child {
        border-left-width: 0;
    }
    .dash-totals-section:last-child {
        border-right-width: 0;
    }
    .dash-field {
        display: inline-block;
        font-size: calc(10px + 0.28vw);
    }
    .cell-values-zero {
        opacity: 0.3;
    }

    .dash-ids {}
    .dash-name strong {
        color: #fff;
    }
    .dash-separator {
        opacity: 0.4;
        margin: 0 2px;
    }
    .dash-mins {}
    .dash-percent {}

    @media (min-width:1200px) {
        .dash-cell {
            padding-bottom: 71px;
        }
        .dash-totals {
            height: 73px;
        }
        .dash-totals-section {
            border-width: 2px;
            border-top-width: 4px;
        }
        .dash-totals {
            height: 73px;
        }
        .dash-totals {
            height: 73px;
        }
    }

</style>